export const computeFaIconClassName = (icon: string): string => {
  const isPrefix = new RegExp(/^fa[bsr]\s/gm);
  if (isPrefix.test(icon)) {
    return icon;
  }
  return `fab fa-${icon}`;
};
